export const environment = {
    production: true,
    API_URL: 'https://api.panel.eremu.es',
    WS_URL: 'api.panel.eremu.es',
};
